module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/dropbox-2363df4e541e7a2c9e5e5aee4cbc1c75.svg";